import { CHECK_STATUS } from '../types';
import { getHardwareIdentity } from '@upshow/brightsign/src';

export const id = 'brightsignHardware';
export const label = 'Hardware Identity';

// Not `async` — this check has no real async work, and an async function with no
// `await` fails CRA's build (`require-await`). Still returns a real Promise so it
// satisfies the same contract every other check follows.
export function run (_ctx) {
  const start = Date.now();
  const identity = getHardwareIdentity();
  const durationMs = Date.now() - start;

  let result;

  if (!identity.available) {
    result = {
      id,
      label,
      status: CHECK_STATUS.SKIPPED,
      detail: 'Not checked — deviceinfo unavailable',
      detailData: { notChecked: true, reason: identity.reason },
      durationMs,
    };
  } else {
    result = {
      id,
      label,
      status: CHECK_STATUS.PASS,
      detail: `${identity.model || 'Unknown model'} — ${identity.osVersion || 'unknown OS'}`,
      detailData: {
        model: identity.model,
        family: identity.family,
        osVersion: identity.osVersion,
        bootVersion: identity.bootVersion,
        serialNumber: identity.serialNumber,
      },
      durationMs,
    };
  }

  return Promise.resolve(result);
}
